/**
 * StudentActivityTab.jsx
 * Son aktivite kayitlarini zaman serisi olarak gosterir.
 */
import { useLanguage } from '../../contexts/LanguageContext';
import { EmptyState } from '../../components/admin';
import { Activity } from 'lucide-react';

/**
 * Ham snake_case action key'ini insan-okur etikete çevirir.
 * Önce i18n sözlüğü (admin.studentHub.action.<key>) denenir; çeviri yoksa
 * snake_case fallback uygulanır (alt çizgi/nokta -> boşluk, ilk harf büyük).
 * Ham snake_case asla kullanıcıya gösterilmez.
 */
function prettifyAction(action) {
  const words = String(action).replace(/[_.]+/g, ' ').trim();
  if (!words) return '-';
  return words.charAt(0).toUpperCase() + words.slice(1);
}

function actionLabel(action, t) {
  if (!action) return '-';
  const key = `admin.studentHub.action.${action}`;
  const label = t(key);
  // t() çeviri bulamazsa key'in kendisini döndürür -> fallback'e düş
  return label === key ? prettifyAction(action) : label;
}

export default function StudentActivityTab({ detail }) {
  const { t, lang } = useLanguage();

  const activity = detail?.activity || [];

  if (activity.length === 0) {
    return <EmptyState title={t('admin.studentHub.activity_empty')} icon={<Activity size={40} strokeWidth={1.5} />} />;
  }

  return (
    <div className="relative">
      <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-[var(--border-light)]" aria-hidden />
      <div className="space-y-0">
        {activity.map((log, i) => (
          <div
            key={log._id || log.log_id || i}
            className="flex gap-4 pl-8 pb-4 relative"
            data-testid={`activity-row-${i}`}
          >
            <div className="absolute left-3 top-1 w-2.5 h-2.5 rounded-full bg-[var(--brand-primary)] border-2 border-white z-10" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-[var(--text-main)]">
                {actionLabel(log.action || log.event || log.activity_type, t)}
              </p>
              {log.detail && (
                <p className="text-xs text-[var(--text-muted)] mt-0.5 truncate">{log.detail}</p>
              )}
              {log.created_at && (
                <p className="text-[10px] text-[var(--text-muted)] mt-1">
                  {new Date(log.created_at).toLocaleString(lang === 'tr' ? 'tr-TR' : 'en-US')}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
